import {JSSDK} from '@/views/api'
import {useThemeStore} from '@/store/theme'
import config from '@/config'

export const getUrlParams = () => {
    let search = location.search.length > 0 ? location.search.substr(1) : ''
    if (!search) return null
    let Query = {}
    if (search.includes('&')) {
        let strArray = search.split('&')
        strArray.forEach(item => {
            if (item.includes('=')) {
                let arr = item.split('=')
                Query[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1])
            }
        })
    } else {
        let arr = search.split('=')
        Query[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1])
    }
    return Query
}

export const getUUID = () => {
    let e = 32
    const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    const a = t.length
    let n = ''
    for (let i = 0; i < e; i++) {
        n += t.charAt(Math.floor(Math.random() * a))
    }
    return n
}

export const getIsWxClient = () => {
    var ua = navigator.userAgent.toLowerCase()
    return ua.match(/MicroMessenger/i) == 'micromessenger'
}
export const weChatLogin = (appid, url) => {
    let redirect_url = encodeURIComponent(url)
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
}

export const LoadWechatConfig = (url, title, sharePhotoUrl, shareDesc) => {
    JSSDK({
        url
    }).then(res => {
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'wx-open-launch-weapp'
            ], // 必填，需要使用的JS接口列表
            openTagList: [] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        wx.ready(() => {
            wx.checkJsApi({
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline'], // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
                success: function (res) {
                    // 以键值对的形式返回，可用的 api 值true，不可用为false
                    // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                    // alert('checkJsApi' + JSON.stringify(res))
                }
            })
            const shareData = {
                title: title, // 分享标题
                desc: shareDesc, // 分享描述
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                imgUrl: sharePhotoUrl, // 分享图标
                success: function () {
                    // 设置成功
                    // alert('设置成功updateAppMessageShareData')
                }
            }
            wx.updateAppMessageShareData(shareData)
            wx.updateTimelineShareData(shareData)
            try {
                wx.onMenuShareAppMessage(shareData)
                wx.onMenuShareTimeline(shareData)
            } catch (e) {}
        })
        wx.error(function (res) {
            // alert(JSON.stringify(res))
        })
    })
}

export const throttle = fn => {
    let flag = true
    return function () {
        if (!flag) {
            return false
        }

        flag = false
        setTimeout(() => {
            fn()
            flag = true
        }, 200)
    }
}

// export const debounce = (fn, delay) => {
//     //接收要执行的函数，以及延迟时间

//     //定义延迟定时器timer
//     let timer = null
//     //这里需要定义一个新函数，用于作为返回值
//     const _debounce = function (...arg) {
//         // console.log(arg)
//         //判断timer是否存在，有的话就清除
//         if (timer) clearTimeout(timer)

//         //通过延迟时间，来确定要执行的时机
//         timer = setTimeout(() => {
//             fn.apply(this, arg)
//             //执行完应当执行的函数，应该将timer置为null
//             timer = null
//         }, delay)
//     }

//     return _debounce
// }

// 防抖函数
export const debounce = (fn, delay)=> {
    let timer = null
    return function (...args) {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
            fn.apply(this, args)
        }, delay)
    }
}

// 获取图片宽高
export const getImageInfo = url => {
    return new Promise((resolve, reject) => {
        let img = new Image()
        img.src = url
        img.onload = () => {
            console.log(img.size)
            resolve({
                width: img.width,
                height: img.height
            })
        }
    })
}

// 获取网络文件的名字
export const getFileName = str => {
    return str.includes('?') ? str.split('?')[0].substr(str.split('?')[0].lastIndexOf('/') + 1) : str.substr(str.lastIndexOf('/') + 1)
}

export const base64ToBlob = code => {
    let parts = code.split(';base64,')
    let contentType = parts[0].split(':')[1]
    let raw = window.atob(parts[1])
    let rawLength = raw.length
    let uInt8Array = new Uint8Array(rawLength)
    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
    }
    return new window.Blob([uInt8Array], {
        type: contentType
    })
}

export const randomString = e => {
    e = e || 32
    let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678',
        a = t.length,
        n = ''
    for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
    return n
}

// 根据时间返回星期几
export const getWeek = dateStr => {
    let weekNum = new Date(dateStr).getDay()
    let week = ''
    switch (weekNum) {
        case 0:
            week = '星期天'
            break
        case 1:
            week = '星期一'
            break
        case 2:
            week = '星期二'
            break
        case 3:
            week = '星期三'
            break
        case 4:
            week = '星期四'
            break
        case 5:
            week = '星期五'
            break
        case 6:
            week = '星期六'
            break
    }
    return week
}

export const computedResources = name => {
    // return `./1.4/SKIN_8/${name}`
    const themeStore = useThemeStore()
    if (themeStore.theme.skinType) {
        return `https://res.kapaisy.com/config/skin/${themeStore.theme.skinType}/${name}`
    } else {
        return null
    }
}

// 判断是否qq浏览器
export const IsQQBrowser = () => {
    const u = navigator.userAgent
    var qq = u.includes('QQBrowser')
    var wx =
        u.match(/MicroMessenger/i) &&
        u
            .match(/MicroMessenger/i)
            .toString()
            .toLowerCase() == 'micromessenger'
    return qq && !wx
}

// 根据数字大小 超过一千显示1k+  超过一万显示1w+
export const formatNumber = num => {
    if (num > 10000 && num < 100000) {
        return (num / 10000).toFixed(2) + 'w+'
    } else if (num > 100000 && num < 1000000) {
        return (num / 10000).toFixed(1) + 'w+'
    } else if (num > 1000000) {
        return '99w+'
    } else {
        return num
    }
}

/**
 * base64转file
 * */
export const base64ToFile = (base64String, fileName) => {
    return new Promise((resolve, reject) => {
        // 检查 Base64 字符串的前缀
        const prefix = 'data:image/png;base64,'
        if (!base64String.startsWith(prefix)) {
            reject(new Error('Base64 string does not have the correct prefix.'))
            return
        }

        // 解码 Base64 字符串
        const byteCharacters = atob(base64String.slice(prefix.length))
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)

        // 创建 Blob 对象
        const blob = new Blob([byteArray], {type: 'image/png'})

        // 创建 File 对象
        const file = new File([blob], fileName, {type: 'image/png'})

        resolve(file)
    })
}

/**
 * file转base64
 * */
export const fileToBase64 = file => {
    return new Promise((resolve, reject) => {
        // 创建 FileReader 对象
        const reader = new FileReader()

        // 当文件读取完成时执行的回调函数
        reader.onload = () => {
            // 使用结果解析为 Base64 字符串
            const str = reader.result.split(',')[1]
            const base64String = str.startsWith('data:') ? str : `data:image/png;base64,${str}`
            resolve(base64String)
        }

        // 如果读取文件出错时执行的回调函数
        reader.onerror = error => {
            reject(error)
        }

        // 读取文件为 Data URL（Base64）
        reader.readAsDataURL(file)
    })
}

// 计算包大小
export const buildPackageSize = size => {
    let newSize = ''
    if (size < 1024) {
        newSize = `${size}B`
    } else if (size < 1024 * 1024) {
        newSize = `${(size / 1024).toFixed(2)}KB`
    } else if (size < 1024 * 1024 * 1024) {
        newSize = `${(size / 1024 / 1024).toFixed(2)}MB`
    } else if (size < 1024 * 1024 * 1024 * 1024) {
        newSize = `${(size / 1024 / 1024 / 1024).toFixed(2)}GB`
    }
    return newSize
}
